import { THEMES } from "./theme";
import { ProtonPalette } from "./types";
import { LIGHT_STYLESHEET } from "./lightTheme/stylesheet";
import { DARK_STYLESHEET } from "./darkTheme/stylesheet";
import { ProtonStyleSheet } from "./types";

export const generateStylesheet = (
  palette: ProtonPalette,
  theme: string
): ProtonStyleSheet => {
  const themeVariables =
    theme === THEMES.DARK ? DARK_STYLESHEET : LIGHT_STYLESHEET;

  if (palette) {
    const customVars = generateCustomStylesheet(palette);
    return {
      ...themeVariables,
      ...customVars,
    };
  }

  return themeVariables;
};

//overrride theme colors in stylesheet
const generateCustomStylesheet = (
  palette: ProtonPalette
): Partial<ProtonStyleSheet> => {
  return {
    "--proton-color__primary": palette.BRAND.PRIMARY,
    "--proton-color__primary-light": palette.BRAND.PRIMARY_LIGHT,
    "--proton-color__primary-super-light": palette.BRAND.PRIMARY_SUPER_LIGHT,
    "--proton-color__secondary": palette.BRAND.SECONDARY,
    "--proton-color__secondary-light": palette.BRAND.SECONDARY_LIGHT,
    "--proton-color__secondary-super-light":
      palette.BRAND.SECONDARY_SUPER_LIGHT,

    //TODO: add newly generated grayscale color scale
  };
};
